var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 8.5L10.8438 5.15625C11.0312 4.96875 11.0312 4.625 10.8438 4.4375L10.0625 3.65625C9.875 3.46875 9.53125 3.46875 9.34375 3.65625L6 7.03125L2.625 3.65625C2.4375 3.46875 2.09375 3.46875 1.90625 3.65625L1.125 4.4375C0.9375 4.625 0.9375 4.96875 1.125 5.15625L4.5 8.5L1.125 11.875C0.9375 12.0625 0.9375 12.4062 1.125 12.5938L1.90625 13.375C2.09375 13.5625 2.4375 13.5625 2.625 13.375L6 10L9.34375 13.375C9.53125 13.5625 9.875 13.5625 10.0625 13.375L10.8438 12.5938C11.0312 12.4062 11.0312 12.0625 10.8438 11.875L7.46875 8.5Z",
    fill: "#07080C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f45fa2fd16b877c504d347768c84ca66.svg";
export { ForwardRef as ReactComponent };